export default __webpack_public_path__ + "static/inferno-4a794ab07c69fd196bc2d023288ea0ee.mp4";